<template>
    <div class="social-registration-container">
        <div class="titles">
            <p class="title">LET'S GET YOUR PROFILE SET UP</p>
            <p class="subtitle">
                We'll pull key info from your socials to start your profile. You can always
                edit these details later.
            </p>
        </div>
        <div class="social-form">
            <form novalidate>
                <p>CONFIRM WEBSITE</p>
                <div class="website-input">
                    <input
                        v-model="formData.website"
                        class="form-control"
                        type="text"
                        name="website"
                        placeholder="Enter URL"
                    />
                </div>
                <p>SOCIAL URLS</p>
                <div class="facebook-input">
                    <img
                        class="facebook-icon"
                        src="/images/icons/social/facebook-yellow.png"
                    />
                    <input
                        v-model="formData.Facebook"
                        class="form-control"
                        type="text"
                        name="facebook"
                        placeholder="Facebook"
                    />
                </div>
                <div class="instagram-input">
                    <img
                        class="instagram-icon"
                        src="/images/icons/social/instagram-yellow.png"
                    />
                    <input
                        v-model="formData.Instagram"
                        class="form-control"
                        type="text"
                        name="instagram"
                        placeholder="Instagram"
                    />
                </div>
                <div class="yelp-input">
                    <img class="yelp-icon" src="/images/icons/social/yelp-yellow.png" />
                    <input
                        v-model="formData.Yelp"
                        class="form-control"
                        type="text"
                        name="yelp"
                        placeholder="Yelp"
                    />
                </div>
            </form>
        </div>
        <div class="step-action">
            <button @click="handleNextStep">CONTINUE</button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'SocialRegistration',

        props: {
            defaultVals: {
                type: Object,
                required: false,
                default: null
            }
        },

        data: () => ({
            formData: {
                website: '',
                Facebook: '',
                Instagram: '',
                Yelp: ''
            }
        }),

        methods: {
            handleNextStep() {
                this.$emit('next', this.formData)
            }
        },

        watch: {
            defaultVals: {
                immediate: true,
                handler(newVal) {
                    if (newVal) {
                        this.formData.website = newVal.website
                        this.formData.Facebook = newVal.Facebook
                        this.formData.Instagram = newVal.Instagram
                        this.formData.Yelp = newVal.Yelp
                    }
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .social-registration-container {
        flex: 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 683px;
        height: 538px;

        .titles {
            order: 1;
            flex: 0 0 auto;

            .title {
                margin-top: 50px;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 600;
                font-size: 21px;
                line-height: 24px;
                letter-spacing: 3px;
                text-transform: uppercase;
                color: white;
                text-align: center;
            }

            .subtitle {
                width: 450px;
                height: 81px;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 27px;
                letter-spacing: 3px;
                color: white;
                text-align: center;
                margin-top: 20px;
                margin-left: auto;
                margin-right: auto;
            }
        }

        .social-form {
            order: 2;
            flex: 0 0 auto;

            form {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                p {
                    font-family: 'Instrument Sans';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 22px;
                    text-align: center;
                    letter-spacing: 0.1em;
                    text-transform: uppercase;
                    color: white;
                    margin-top: 20px;
                    margin-bottom: 0px;
                }

                input {
                    width: 446.59px;
                    height: 45px;
                    border: 1px solid white;
                    border-radius: 50px;
                    background: transparent;
                    color: white;

                    input::placeholder {
                        color: white;
                    }
                }

                input[name='website'] {
                    padding-left: 42.84px;
                    padding-right: 23.56px;
                    margin-top: 15px;
                }

                input[name='facebook'],
                input[name='instagram'],
                input[name='yelp'] {
                    padding-left: 52.5px;
                    padding-right: 23.56px;
                }

                img {
                    position: relative;
                    top: 35px;
                    left: 22px;
                }
            }
        }

        .step-action {
            order: 6;
            flex: 0 0 auto;
            margin-top: 20px;
            margin-bottom: 50px;

            button {
                background-color: #e2ee79;
                border-radius: 50px;
                height: 62px;
                width: 467px;
                padding: 20px;
                display: flex;
                gap: 10px;
                align-items: center;
                justify-content: center;
                border: none;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                text-align: center;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #1b0d29;
            }
        }
    }
</style>
